export function changeLanguage(languageCode: string): void {
  localStorage.setItem("language_code", languageCode);
}

export function getLanguage(): string {
  return localStorage.getItem("language_code") || "en";
}
